<nav ngbNav #navSeatMap="ngbNav" [destroyOnHide]="false" (navChange)="onNavChange($event)">
  @for (outboundFlight of flight.outboundFlights; track outboundFlight; let i = $index) {
    <ng-container ngbNavItem>
      <button ngbNavLink>
        <span i18n="@@seatmapOutbound">Outbound</span> {{ outboundFlight.originAirport }} -
        {{ outboundFlight.destinationAirport }}
      </button>
      <ng-template ngbNavContent>
        <div class="flight-seat-map-container">
          @if (showSeatmap) {
            <div class="seat-map">
              @if (user && seatingPreference) {
                <div class="flex-row-container flex-row-container--center">
                  <b>{{ user.title }} {{ user.forename }} {{ user.surname }}</b
                  >&nbsp; <span i18n="@@seatmapSeatPreference">Seating preference:</span>&nbsp;
                  {{ seatingPreference }}
                </div>
              }
              @if (showLoyalty && showSeatmap) {
                <div class="flight-extras">
                  <app-flight-extras-recalculate
                    [operatingCarrierName]="outboundFlight.operatingCarrierName"
                    [loyaltyCode]="loyaltyCodes[i]"
                    [dob]="travellerDob"
                    [dobMandatory]="dobMandatory"
                    [isGuest]="isGuest"
                    [travellerId]="travellerId"
                    (loyaltyCodeChanged)="setLoyaltyCode($event, i, false, travellerId)"
                    (recalculate)="recalculateFlightSeat(i, travellerId)"
                    (setTravellerDob)="setTravellerDob($event)"
                  ></app-flight-extras-recalculate>
                </div>
              }
              <app-flight-seat-map
                [flight]="outboundFlight"
                [supplier]="flight.source"
                [travellerId]="travellerId"
                [flightSeats]="outboundSeats?.[i]"
                [requestActive]="activeRequests?.[i]"
                [selectedSeatWithId]="selectedSeatWithId"
                (seat)="getSeat($event)"
                (loyaltyRetrieved)="setLoyaltyCode($event, i)"
                (setSeatsReceived)="setSeatsReceived($event)"
              ></app-flight-seat-map>
            </div>
          }
          <div>
            <app-flight-amenities
              [currency]="flight?.total?.currency"
              [supplier]="supplier"
              [flights]="flight?.outboundFlights"
              [extraOptions]="outboundFlightsExtras?.[0]"
            ></app-flight-amenities>
            @if (outboundFlightsExtras.length && showAllExtras) {
              <div
                class="flight-extras"
                [ngClass]="{ 'has-only-extras': showAllExtras && !seatsReceived }"
              >
                <app-flight-extras
                  [parentTabId]="activeTab"
                  [showTFXLuggage]="
                    i === 0 &&
                    supplier === ServiceProvider.Travelfusion &&
                    (luggagePerPax || (travellerIndex === 0 && !luggagePerPax))
                  "
                  [hideAncillary]="
                    i !== 0 && supplier === ServiceProvider.Travelfusion && ancillaryPerBooking
                      ? true
                      : false
                  "
                  [supplier]="supplier"
                  (flightExtras)="getExtras($event)"
                  [selectedFlightExtrasChange]="selectedFlightExtrasChange"
                  [flights]="flight.outboundFlights"
                  [travellerId]="travellerId"
                  [extraOptions]="outboundFlightsExtras?.[0]"
                  [flightId]="outboundFlight?.id"
                  [extrasPlaceholder]="extrasPlaceholder"
                  [baggagePlaceholder]="baggagePlaceholder"
                  [ancillaryPlaceholder]="ancillaryPlaceholder"
                ></app-flight-extras>
                <pre>{{ additionalDetails | json }}</pre>
              </div>
            }
          </div>
        </div>
      </ng-template>
    </ng-container>
  }
  @for (inboundFlight of flight.inboundFlights; track inboundFlight; let i = $index) {
    <ng-container ngbNavItem>
      <button ngbNavLink>
        <span i18n="@@seatmapInbound">Inbound</span> {{ inboundFlight.originAirport }} -
        {{ inboundFlight.destinationAirport }}
      </button>
      <ng-template ngbNavContent>
        <div class="flight-seat-map-container">
          @if (showSeatmap) {
            <div class="seat-map">
              @if (showLoyalty && showSeatmap) {
                <div class="flight-extras">
                  <app-flight-extras-recalculate
                    [operatingCarrierName]="inboundFlight.operatingCarrierName"
                    [loyaltyCode]="loyaltyCodes[flight.outboundFlights.length + i]"
                    [travellerId]="travellerId"
                    [dob]="travellerDob"
                    [dobMandatory]="dobMandatory"
                    [isGuest]="isGuest"
                    (loyaltyCodeChanged)="setLoyaltyCode($event, i, true, travellerId)"
                    (recalculate)="recalculateFlightSeat(i, travellerId, true)"
                    (setTravellerDob)="setTravellerDob($event)"
                  ></app-flight-extras-recalculate>
                </div>
              }
              <app-flight-seat-map
                [flight]="inboundFlight"
                [supplier]="flight.source"
                [flightSeats]="inboundSeats?.[i]"
                [travellerId]="travellerId"
                [requestActive]="activeRequests?.[flight.outboundFlights.length + i]"
                [selectedSeatWithId]="selectedSeatWithId"
                (seat)="getSeat($event)"
                (loyaltyRetrieved)="setLoyaltyCode($event, i, true)"
                (setSeatsReceived)="setSeatsReceived($event)"
              ></app-flight-seat-map>
            </div>
          }
          <div>
            <app-flight-amenities
              [currency]="flight?.total?.currency"
              [supplier]="supplier"
              [flights]="flight?.inboundFlights"
              [extraOptions]="inboundFlightsExtras?.[0]"
            ></app-flight-amenities>
            @if (showAllExtras) {
              <div
                [ngClass]="{ 'has-only-extras': showAllExtras && !seatsReceived }"
                class="flight-extras"
              >
                <app-flight-extras
                  [parentTabId]="activeTab"
                  [showTFXLuggage]="
                    i === 0 &&
                    supplier === ServiceProvider.Travelfusion &&
                    !luggagePerBooking &&
                    (luggagePerPax || (travellerIndex === 0 && !luggagePerPax))
                  "
                  [hideAncillary]="
                    supplier === ServiceProvider.Travelfusion && ancillaryPerBooking ? true : false
                  "
                  [hideExtras]="supplier === ServiceProvider.Travelfusion"
                  [supplier]="supplier"
                  (flightExtras)="getExtras($event)"
                  [selectedFlightExtrasChange]="selectedFlightExtrasChange"
                  [flights]="flight.inboundFlights"
                  [travellerId]="travellerId"
                  [flightId]="inboundFlight?.id"
                  [extraOptions]="inboundFlightsExtras?.[0]"
                  [extrasPlaceholder]="extrasPlaceholder"
                  [baggagePlaceholder]="baggagePlaceholder"
                  [ancillaryPlaceholder]="ancillaryPlaceholder"
                ></app-flight-extras>
                <pre>{{ additionalDetails | json }}</pre>
              </div>
            }
          </div>
        </div>
      </ng-template>
    </ng-container>
  }
</nav>
<div [ngbNavOutlet]="navSeatMap" class="seatmap"></div>
@if (showSeatmap) {
  <div class="key-container">
    <div class="container">
      <div id="available-seat" class="seat available"></div>
      <label for="available-seat" i18n="@@available-seat">Available&#10;Seat</label>
    </div>
    <div class="container">
      <div id="not-available-seat" class="seat not-available"></div>
      <label for="not-available-seat" i18n="@@not-available-seat">Seat not&#10;available</label>
    </div>
    <div class="container">
      <div id="selected-seat" class="seat selected"></div>
      <label for="selected-seat" i18n="@@selected-seat">Seat&#10;Selected</label>
    </div>
    <div class="container">
      <div id="no-seat" class="seat no-seat"></div>
      <label for="no-seat" i18n="@@no-seat">No Seat</label>
    </div>
  </div>
}
